import { useCallback, FC } from 'react';

import { Menu as MuiMenu, MenuProps as MuiMenuProps } from '@mui/material';
import { useNavigate } from 'react-router-dom';

import { InspiredPaymentPortalAPIAccessibleAccountsAccessibleAccountDto as AccessibleAccount } from 'shared/models/payments/inspiredPaymentPortalAPIAccessibleAccountsAccessibleAccountDto';
import { useAccessibleAccounts } from 'shared/providers/AccessibleAccounts';
import { ROUTES } from 'shared/constants';
import { useFilterSessionStorage } from 'shared/components/Filter/hooks';

import { MenuItem } from '../MenuItem';
import { useInvalidateObserverQueries } from './Menu.hooks';

interface MenuProps extends MuiMenuProps {
  onClose: () => void;
}

export const Menu: FC<MenuProps> = ({ onClose, ...props }) => {
  const { availableAccounts, setCurrentAccount } = useAccessibleAccounts();
  const { setFiltersToStorage } = useFilterSessionStorage();

  const invalidateObserverQueries = useInvalidateObserverQueries();

  const navigate = useNavigate();

  const onMasquerade = useCallback(
    (account: AccessibleAccount) => {
      setFiltersToStorage({
        academicYear:
          account.filters.academicYears[account.filters.academicYears.length - 1]?.value || ''
      });
      setCurrentAccount(account);
      invalidateObserverQueries();
      navigate(ROUTES.HOME);
      onClose();
    },
    [setCurrentAccount, onClose, navigate, invalidateObserverQueries, setFiltersToStorage]
  );

  return (
    <MuiMenu {...props} onClose={onClose}>
      {availableAccounts.map(account => (
        <MenuItem key={account.personGuid} {...account} onClick={onMasquerade} />
      ))}
    </MuiMenu>
  );
};
